export const gray = {
  // New design system colors
  gray0: '#ffffff',
  gray1: '#fafafa',
  gray2: '#f5f5f5',
  gray3: '#f0f0f0',
  gray4: '#d9d9d9',
  gray5: '#bfbfbf',
  gray6: '#8c8c8c',
  gray7: '#595959',
  gray8: '#434343',
  gray9: '#262626',
  gray10: '#1f1f1f',
  gray11: '#141414',
  gray12: '#000000',
  // Old design system colors
  gray100: '#FAFAFB',
  gray200: '#EDEDED',
  gray300: '#C9C9C9',
  gray400: '#949494',
  gray500: '#4E4E4E',
  gray600: '#433939',
  gray700: '#38272A',
  gray800: '#262626',
  gray900: '#0E0E10',
  primaryGray: '#999999',
};
